import styled from 'styled-components'
import { Button as DefaultButton } from '~components'

export const Image = styled.img`
  border-radius: ${({ theme }) => theme.border.radius.medium};
  width: 350px;
  display: block;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`

export const PrimaryButton = styled(DefaultButton)`
  margin-top: ${({ theme }) => theme.spacing.km8};
`

export const SecondaryButton = styled(DefaultButton)`
  margin-top: ${({ theme }) => theme.spacing.km1};
`
